import { toRef, computed, createBlock, openBlock, mergeProps, unref, isRef } from "vue";
import { useField } from "vee-validate";
import { isString } from "lodash-es";
import "moment";
import { uuid } from "../../utils/uuid.js";
import "../../plugins/apollo.js";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                       */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                      */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
/* empty css                 */
import { VSwitch } from "vuetify/components/VSwitch";
const _sfc_main = {
  __name: "BanzaSwitch",
  props: {
    modelValue: {
      type: Boolean
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: [String],
      default: ""
    },
    preset: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: ""
    },
    errorMessages: {
      type: [String, Array],
      default: null
    },
    hideDetails: {
      type: [String, Boolean],
      default: "auto"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    preset: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const { value, handleChange, errors } = useField(
      () => props.name || uuid(),
      toRef(() => props.rules),
      {
        type: "checkbox",
        checkedValue: true,
        uncheckedValue: false,
        syncVModel: true
      }
    );
    const fieldErrors = computed(
      () => props.errorMessages ? [].concat(props.errorMessages) : errors.value || []
    );
    const hideDetails = computed(
      () => props.hideDetails === "auto" ? fieldErrors.value.filter(isString).length === 0 : props.hideDetails
    );
    const { attrs } = useTheme({
      componentKey: "BanzaSwitch",
      presetName: toRef(() => props.preset)
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(VSwitch, mergeProps({
        class: "b-switch",
        modelValue: unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(value) ? value.value = $event : null),
        label: __props.label,
        color: "primary",
        "error-messages": unref(fieldErrors),
        "hide-details": unref(hideDetails),
        readonly: __props.readonly,
        disabled: __props.disabled,
        onChange: _cache[1] || (_cache[1] = (e) => {
          if (__props.readonly || __props.disabled) {
            e.preventDefault();
            return;
          }
          unref(handleChange)(e);
        })
      }, unref(attrs)), null, 16, ["modelValue", "label", "error-messages", "hide-details", "readonly", "disabled"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
